import { BookableShipmentSavedSearch } from 'apps/fleet-planner/types'
import formatCurrency from 'utils/formatCurrency'

export const getRate = ({
  rate,
  rateType,
}: Pick<BookableShipmentSavedSearch, 'rate' | 'rateType'>): string => {
  if (!rateType) {
    return 'Any Rate'
  }
  return `${formatCurrency(rate, false)} ${rateType === 'all_in' ? 'all-in' : 'per mile'}`
}
